export default [
    {
        path: "/apartment/:action?/:id(\\d+)?",
        name: "ApartmentCreateOrEdit",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_KEY_MOBIL",
                "G_CLEPASS",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_RESIDENCES",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
            ],
            entity: "apartment",
            tab: "residences",
        },
        component: () => import("@/views/apartment/CreateOrEdit.vue"),
    },
    {
        path: "/apartment/:id(\\d+)/:tab(details|authorizations|codes|central-units|subaccounts)?/:page_num?",
        name: "Apartment",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_KEY_MOBIL",
                "G_CLEPASS",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_RESIDENCES",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
            ],
            entity: "apartment",
            tab: "residences",
        },
        component: () => import("@/views/apartment/Details.vue"),
    },
    {
        path: "/apartment/:apartmentId(\\d+)/accessories/mobipass/:mobipassId",
        name: "ApartmentAccessoriesMobipass",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_RESIDENCES",
                "G_KEY_MOBIL",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
            ],
        },
        component: () =>
            import("@/views/accessories/mobipass/CreateOrEdit.vue"),
    },
]
